import { render, staticRenderFns } from "./SelecaoTempoCurva.vue?vue&type=template&id=6a2a11b2&"
import script from "./SelecaoTempoCurva.vue?vue&type=script&lang=js&"
export * from "./SelecaoTempoCurva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports